import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Toastr, Button, Tooltip } from "@revvsales/components";

import SHIELD from "../../assets/ic-shield.svg";

// Actions Imports
import {
  // approveRejectDoc,
  // fetchAndUpdateDocMeta,
  fetchDocRecipientListAction,
  acceptanceApprovalStatusCheck,
  updateEmailMessage,
} from "../../actions/DocumentActions";
import SubmitConfirmationPopup from "./SubmitConfirmationPopup";

import { GlobalUtils } from "../../utils";

// Destructuring
const { isChromeBrowser, isMobileBrowser } = GlobalUtils;
class AcceptanceApproveRejectConfirmation extends Component {
  state = {
    errMsg: "",
    isVideoReq: false,
    reviewerEmailMessage: "",
    showLoaderClicktoRecord: false,
    showLoaderClicktoRecordMandatory: false,
    isChrome: false,
    isMobile: false,
  };

  componentDidMount() {
    if (this.props.senderIsAcceptor) {
      this.setState({
        isVideoReq: !!this.props.userDetails.video_kyc,
      });
    } else {
      this.setState({
        isVideoReq: !!this.props.videoKyc,
      });
    }
    const isChromeVal = isChromeBrowser();
    const isMobileVal = isMobileBrowser();
    this.setState({ isChrome: isChromeVal, isMobile: isMobileVal });
  }

  _changeReviewMessage = e => {
    this.setState({ reviewerEmailMessage: e.target.value });
  };

  _approveRejectDoc = e => {
    const { isChrome, isMobile } = this.state;
    if (
      e.target.innerText === "Start video acceptance" ||
      e.target.innerText === "Start video reject"
    ) {
      if (isChrome && !isMobile) {
        this.setState({ showLoaderClicktoRecordMandatory: true });
        this.props.updateMultipleState({
          showRecordVideoPopupForRecording: true,
        });
        // eslint-disable-next-line no-new
        new Promise(() => {
          navigator.mediaDevices
            .getUserMedia({
              video: true,
              audio: true,
            })
            .then(() => {
              this.setState({ showLoaderClicktoRecordMandatory: false });
              this.props.updateMultipleState({
                acceptanceApproveRejectConfirmation: false,
                showRecordVideoPopup: true,
              });
            })
            .catch(() => {
              this.setState({ showLoaderClicktoRecordMandatory: false });
              this.props.updateMultipleState({
                acceptanceApproveRejectConfirmation: false,
                showAllowCameraPopup: true,
              });
            });
        });
      }
    } else {
      this.props
        .acceptanceApprovalStatusCheck(
          this.props.docID,
          this.props.sharingHash,
          this.props.view,
        )
        .then(() => {
          this.props.togglePopUp("acceptanceApproveRejectConfirmation", false);
          if (!this.props.isSharing) {
            this.props.fetchDocRecipientListAction(this.props.docID);
          }
          if (this.props.view === "accept") {
            if (this.props.isSharing) {
              this.props.getUpdatedShareddata();
            }
            this.props.updateMultipleState({
              acceptanceApproveRejectConfirmation: false,
              acceptAndRejectBtn: false,
              docAcceptanceConfirmationPopup: true,
            });
          } else if (this.props.view === "reject") {
            if (this.props.isSharing) {
              this.props.getUpdatedShareddata();
            }
            this.props.updateMultipleState({
              acceptanceApproveRejectConfirmation: false,
              acceptAndRejectBtn: false,
              docRejecteConfirmationPopup: true,
            });
          }
        })
        .catch(() => {
          Toastr.showToastr({
            type: "failure",
            message: `Oops! Couldn't ${
              this.props.view
            } document. Please try again.`,
            timeout: 3000,
          });
          this.props.updateMultipleState({
            acceptanceApproveRejectConfirmation: false,
            acceptAndRejectBtn: false,
          });
        });
    }
  };

  _checkFormFields = () =>
    // if true - dont show the send confirmation popup

    // const { fieldsUsed, showForm } = this.props;
    // if (!fieldsUsed || !fieldsUsed.length || !showForm) {
    //   return true;
    // }
    // for (let i = 0; i < fieldsUsed.length; i += 1) {
    //   const element = fieldsUsed[i];
    //   if (element && !element.value) {
    //     return false;
    //   }
    // }
    true;
  //

  _handleRecordVideo = () => {
    this.setState({ showLoaderClicktoRecord: true });
    this.props.updateEmailMessage(this.state.reviewerEmailMessage);
    this.props.updateMultipleState({
      showRecordVideoPopupForRecording: true,
    });
    // eslint-disable-next-line no-new
    new Promise(() => {
      navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: true,
        })
        .then(() => {
          this.setState({ showLoaderClicktoRecord: false });
          this.props.updateMultipleState({
            acceptanceApproveRejectConfirmation: false,
            showRecordVideoPopup: true,
          });
        })
        .catch(() => {
          this.setState({ showLoaderClicktoRecord: false });
          this.props.updateMultipleState({
            acceptanceApproveRejectConfirmation: false,
            showAllowCameraPopup: true,
          });
        });
    });
  };

  _renderOverlayText = () => (
    <div className="accept-reject-overlay-text">
      <span>More Examples</span>
      <span>
        &quot;I Clark Kent, accept the position of Investigative Reporter in The
        Daily Planet as mentioned in this offer letter.&quot;
      </span>
      <span>
        &quot;I, George Wade, authorize Lucy Kelson to make the purchases
        underlined in this document.&quot;
      </span>
    </div>
  );

  _renderBodyVideoReq = (isChrome, isMobile) => (
    <div>
      <div className="video-req-modal-body">
        <div className="video-req-body-left">
          <div className="video-req-body-icons">
            <FontAwesomeIcon
              icon={["fas", "video"]}
              size="3x"
              color="#7d8da7"
            />
            <FontAwesomeIcon icon={["fas", "user"]} size="3x" color="#7d8da7" />
          </div>
          <div className="video-req-body-left-text">
            How to accept document by video KYC?
          </div>
        </div>
        <vr />
        <div className="video-req-body-right">
          <span>
            Please record a video of yourself stating that you accept this
            document along with any terms and conditions that are a part of the
            document.
          </span>
          <Tooltip
            placement="right"
            overlayClassName="accept-reject-tooltip"
            overlay={this._renderOverlayText}
            align={{
              offset: [6, 0],
            }}>
            <span className="video-req-body-right-bottom">
              Example: &quot;
              <i>
                I, Jane Doe, accept the the terms and conditions in this rental
                agreement on today&apos;s date, January 20, 2021
              </i>
              &quot;
            </span>
          </Tooltip>
        </div>
      </div>
      <div className="emptysigner-popup-warning-section">
        <div>
          <img src={SHIELD} alt="Revv" className="legal-signer-icon" />
        </div>
        <div>
          <div className="emptysigner-popup-legal-subtitle">
            Revv complies with the highest level of safety standards and has
            tight data security measures. Your document and video are completely
            safe and will not be misused in any manner.
          </div>
        </div>
      </div>
      {!isChrome || isMobile ? (
        <div className="attach-video-main">
          <FontAwesomeIcon icon={["far", "info-circle"]} color="red" />
          <p className="allow-camera-hint-text">
            {`Video recording will soon be available on this browser. For now,
            please try this feature on Google Chrome${
              isMobile ? " desktop version." : "."
            }`}
          </p>
        </div>
      ) : (
        <div className="allow-camera-hint-text">
          <FontAwesomeIcon icon={["far", "info-circle"]} /> Allow Revv to access
          your camera and microphone when prompted by the browser
        </div>
      )}
    </div>
  );

  render() {
    const { isChrome, isMobile } = this.state;
    if (!this._checkFormFields()) {
      return (
        <SubmitConfirmationPopup
          onConfirm={this._approveRejectDoc}
          onClose={() => {
            this.props.togglePopUp(
              "acceptanceApproveRejectConfirmation",
              false,
            );
          }}
        />
      );
    }
    return (
      <Modal
        open
        onClose={() =>
          this.props.togglePopUp("acceptanceApproveRejectConfirmation", false)
        }
        closeOnOverlayClick={false}
        center>
        <div className="approvalpopup">
          <div className="approvalpopup-header">
            {this.state.isVideoReq && this.props.view === "accept" ? (
              <p>
                {/* <FontAwesomeIcon icon={["fas", "lock"]} /> */}
                {this.props.createdBy.name} has requested video KYC for document
                acceptance
              </p>
            ) : (
              <p>
                {this.props.view === "accept" ? (
                  <FontAwesomeIcon
                    icon={["fas", "check-square"]}
                    color="green"
                  />
                ) : (
                  <FontAwesomeIcon icon={["far", "ban"]} color="red" />
                )}{" "}
                You are about to{" "}
                {this.props.view === "accept" ? " Accept" : " Reject"} this
                document
              </p>
            )}
          </div>
        </div>
        {this.state.isVideoReq &&
          this.props.view === "accept" &&
          this._renderBodyVideoReq(isChrome, isMobile)}
        {(!this.state.isVideoReq || this.props.view === "reject") && (
          <div className="approvalpopup-note">
            {this.state.isVideoReq && this.props.view === "accept" ? (
              <p className="approvalpopup-workflows-heading">
                {this.props.view === "accept"
                  ? "This document requires a mandatory video KYC/acceptance for authorizing the recipient"
                  : "This document requires a mandatory video KYC/reject for authorizing the recipient"}
              </p>
            ) : (
              <p className="approvalpopup-workflows-heading">
                {this.props.view === "accept"
                  ? "Click Accept document below to give your consent. This action cannot be reversed. The sender will be notified via email. You can add a message for the sender in the form of text or video to accompany the email."
                  : "Click Reject document below to deny consent on this document. This action cannot be reversed. The sender will be notified via email. You can add a message for the sender in the form of text or video to accompany the email."}
              </p>
            )}
            <div className="acceptors-note-wrapper">
              <div className="docsharing-reviewer-email-acceptor">
                <textarea
                  rows="11"
                  placeholder="Start typing your message here"
                  value={`${
                    this.props.emailMessage
                      ? this.props.emailMessage
                      : this.state.reviewerEmailMessage
                  }`}
                  onChange={e => this._changeReviewMessage(e)}
                  data-test="docsharing-reviewer-email-acceptor"
                />
              </div>
              <div className="attach-video">
                <div className="attach-video-main">
                  <FontAwesomeIcon icon={["fal", "video"]} size="3x" />
                  <p className="attachvideo-subhead">
                    Attach video message with email.
                  </p>
                </div>
                {!isChrome || isMobile ? (
                  <div className="attach-video-main">
                    <FontAwesomeIcon
                      icon={["fas", "info-circle"]}
                      color="red"
                    />
                    <p className="attachvideo-text">
                      {`Video recording will soon be available on this browser. For now,
                      please try this feature on Google Chrome${
                        isMobile ? " desktop version." : "."
                      }`}
                    </p>
                  </div>
                ) : (
                  <Button
                    isLoading={this.state.showLoaderClicktoRecord}
                    disabled={this.state.showLoaderClicktoRecord}
                    className="click-to-record"
                    type="two"
                    data-test="docsharing-popup-add-btn"
                    onClick={e => this._handleRecordVideo(e)}>
                    Click to record
                  </Button>
                )}
                {isChrome && !isMobile && (
                  <p className="attachvideo-text">
                    <FontAwesomeIcon icon={["far", "info-circle"]} /> Give Revv
                    permission to use your systems camera and mic in the next
                    step for video recording.
                  </p>
                )}
              </div>
            </div>
            <div className="emptysigner-popup-warning-section">
              <div>
                <img src={SHIELD} alt="Revv" className="legal-signer-icon" />
              </div>
              <div>
                {/* <div className="emptysigner-popup-legal-title">
                Legal, secure, reliable
              </div> */}
                <div className="emptysigner-popup-legal-subtitle">
                  Revv complies with the highest level of safety standards and
                  has tight data security measures. Your document and video are
                  completely safe and will not be misused in any manner.
                </div>
              </div>
            </div>

            <p className="approvalpopup-workflows-heading">
              {this.state.errMsg && (
                <div className="error-message-wrapper">
                  <span className="error-message-icon">
                    <FontAwesomeIcon icon={["far", "times-circle"]} />
                  </span>
                  {this.state.errMsg}
                </div>
              )}
            </p>
            {/* <textarea
                rows="5"
                value={this.state.comment}
                onChange={e => this._changeComment(e)}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              /> */}
          </div>
        )}
        <section className="createquotepopup-footer popup-footer clearfix">
          <div className="footer-actions">
            <Button
              className="btn-transparent"
              data-test="acceptance-popup-cancel-btn"
              onClick={() =>
                this.props.togglePopUp(
                  "acceptanceApproveRejectConfirmation",
                  false,
                )
              }>
              Cancel
            </Button>

            <Button
              data-test="acceptance-popup-accept-btn"
              disabled={
                ((!isChrome || isMobile) &&
                  this.state.isVideoReq &&
                  !(this.props.view === "reject")) ||
                this.state.showLoaderClicktoRecordMandatory
              }
              isLoading={this.state.showLoaderClicktoRecordMandatory}
              className={`${
                this.props.view === "reject" ? "reject-document" : ""
              }`}
              onClick={e => this._approveRejectDoc(e)}>
              {(this.state.isVideoReq &&
                (this.props.view === "accept"
                  ? "Start video acceptance"
                  : "Reject Document")) ||
                (this.props.view === "accept"
                  ? "Accept Document"
                  : "Reject Document")}
            </Button>
          </div>
        </section>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document, docRecipientList, emailMessage } = state.DocumentStore;
  const {
    id: docID,
    docNo,
    fields_used: fieldsUsed = [],
    showForm,
    created_by: createdBy,
  } = document;
  const { documentNotes } = state.NotesStore;
  return {
    docID,
    docNo,
    document,
    documentNotes,
    docRecipientList,
    fieldsUsed,
    showForm,
    createdBy,
    emailMessage,
  };
};

const mapDispatchToProps = {
  acceptanceApprovalStatusCheck,
  fetchDocRecipientListAction,
  updateEmailMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AcceptanceApproveRejectConfirmation);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AcceptanceApproveRejectConfirmation.js